<button
	#blockButton
	class="w-full h-full min-w-0 font-light transition-colors active:border focus:border-2 focus-within:border-2 border-[0.5px] duration-300 gap-1 rounded-md flex justify-start text-gray-800 bg-opacity-70 hover:bg-opacity-70 outline-none hover:cursor-pointer"
	[ngClass]="classes()"
	(dblclick)="onBlockDoubleClick($event)"
	(click)="onBlockClick($event)"
	(keydown)="onKeyDown($event)"
	(focus)="blockFocus.emit()"
	(blur)="blockBlur.emit()"
	[attr.aria-label]="blockInfo_().label"
	[draggable]="draggable()"
	[disabled]="disabled()"
	[attr.tabindex]="disabled() ? -1 : 0"
>
	<i-tabler
		data-testid="block-button-icon"
		*ngIf="blockInfo_().iconName as iconName"
		[ngClass]="iconClasses()"
		[name]="iconName"
	/>
	@if (isEditing()) {
		<textarea
			#textInput
			class="bg-transparent border-none outline-none w-full h-full resize-none overflow-auto"
			[value]="editValue_()"
			(input)="onInputChange($event)"
			(keydown)="onInputKeydown($event)"
			(keydown.backspace)="$event.stopPropagation()"
			(keydown.delete)="$event.stopPropagation()"
			(blur)="onInputBlur()"
		></textarea>
	} @else {
		<span
			class="truncate"
			[ngClass]="
				blockType() === ESigningBlockType.TEXT && !textDefaultValue()
					? 'text-gray-500'
					: ''
			"
		>
			{{ textDefaultValue() || blockInfo_().label }}
		</span>
	}
</button>
